// extracted by mini-css-extract-plugin
export var container = "_9p-0";
export var error = "_9p-9";
export var label = "_9p-5";
export var light = "_9p-6";
export var md = "_9p-3";
export var sm = "_9p-2";
export var thin = "_9p-8";
export var thinBold = "_9p-7";
export var vertical = "_9p-4";
export var xs = "_9p-1";